import { SignIn, SignUp } from '@clerk/clerk-react';
import { LegalLinks } from '../components/home/LegalLinks';

export function AuthPage({ mode }) {
  const Form = mode === 'sign-up' ? SignUp : SignIn;
  return (
    <main className="ledger-auth min-h-screen flex flex-col items-center justify-center gap-5 p-4" style={{ background: 'var(--ledger-bg)' }}>
      <div className="text-center">
        <h1 className="text-3xl font-bold" style={{ color: 'var(--ledger-ink)', letterSpacing: '-0.5px' }}>IceIQ</h1>
        <p className="text-sm" style={{ color: 'var(--ledger-muted)' }}>Fantasy Analytics</p>
      </div>
      <Form routing="path" path={`/${mode}`} />
      <LegalLinks />
    </main>
  );
}

export default AuthPage;
